<template>
  <v-row no-gutters>
    <v-row align="center" no-gutters>
      <v-col cols="5" class="py-0">
        <span class="card-title-font">Produtos do grupo</span>
        <p v-if="errorMessages" class="error--text error-text my-2 pa-2">{{ errorMessages }}</p>
      </v-col>
      <v-col cols="7" class="py-0">
        <v-row align="center" no-gutters>
          <v-spacer />
          <modal-graphql-search-content
            button-activator
            button-text="Escolher produtos"
            :selected-items="localProducts"
            :is-segmentation="false"
            @confirm="confirmProductsChange"
          />
          <div class="pr-3"></div>
          <mf-search v-model="search" dense style="max-width: 300px" hide-details placeholder="Busque um produto" />
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          fixed-header
          height="200px"
          :options.sync="options"
          :items="items"
          :headers="headers"
          no-data-text="Não há produtos neste grupo"
          :footer-props="{ itemsPerPageOptions: [] }"
          :items-per-page="10"
        >
          <template v-slot:[`item.delete`]="{ item }">
            <div>
              <mf-button type="icon" icon="delete" color="cinza-l30" @click="removeItem(item)" />
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import { diacriticSpaceSensitiveRegex } from '@/helpers/search.js'

export default {
  name: 'ProductGroupProductsTable',
  components: {
    ModalGraphqlSearchContent: () => import('@/components/ModalGraphqlSearchContent.vue'),
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    errorMessages: {
      type: [String, Array],
      default: () => '',
    },
  },
  data: () => ({
    search: '',
    options: {},
    localProducts: [],
  }),
  computed: {
    items() {
      if (!this.search) return this.localProducts
      const searchRegex = diacriticSpaceSensitiveRegex(this.search)
      return this.localProducts.filter((product) => product.name.match(searchRegex) || product.sku === this.search)
    },
    headers() {
      const headers = [
        {
          text: 'SKU',
          value: 'sku',
          width: '20%',
        },
        {
          text: 'Nome do produto',
          value: 'name',
          width: '75%',
        },
        {
          text: '',
          value: 'delete',
          sortable: false,
          width: '5%',
        },
      ]
      return headers
    },
  },
  watch: {
    search() {
      this.options.page = 1
    },
    products(val) {
      this.localProducts = val
    },
  },
  methods: {
    removeItem(item) {
      this.localProducts = this.localProducts.filter((product) => product.sku !== item.sku)
      this.$emit('update:products', this.localProducts)
    },
    confirmProductsChange(products) {
      this.localProducts = products.map((product) => ({
        name: product.name,
        sku: product.sku,
      }))
      this.$emit('update:products', this.localProducts)
    },
  },
}
</script>
